// src/components/Calendar/recurrence.js

// A series shares planned maps, but recordings/stats belong to one occurrence.
export function occurrenceSetupFields(event, dateKey) {
  if (dateKey === String(event.startUTC).slice(0, 10)) return {};
  return {matchId: null, teamStatsMatchId: null,
    ...(Array.isArray(event.mapSlots) ? {mapSlots: event.mapSlots.map(slot => {
      const {lineup, ...planned} = slot;
      return {...planned, matchId: "", statsId: "", localMatchId: ""};
    })} : {}),
  };
}

// Expand recurring events to concrete instances between [fromDate, toDate]
// Mirrors the expandRecurringEvents you already use in CalendarView.js
export const expandRecurring = (events, fromDate, toDate) => {
  const expanded = [];
  const from = new Date(fromDate); from.setHours(0,0,0,0);
  const to = new Date(toDate);

  for (const event of (events || [])) {
    const repeat = event.repeat || "none";
    const start  = new Date(event.startUTC);
    const end    = new Date(event.endUTC);
    const durMs  = end - start;

    const exceptions = Array.isArray(event.exceptions) ? event.exceptions : [];
    const overrides  = event.overrides && typeof event.overrides === "object" ? event.overrides : {};

    let until = null;
    if (event.repeatEndDate) {
      const [y,m,d] = event.repeatEndDate.split("-").map(Number);
      until = new Date(y, m-1, d, 23, 59, 59, 999);
    }

    if (repeat === "none") {
      if (end >= from && start <= to) expanded.push(event);
      continue;
    }

    const stepDays =
      repeat === "daily"    ? 1  :
      repeat === "weekly"   ? 7  :
      repeat === "biweekly" ? 14 : 0;

    if (!stepDays) continue;

    // Moved overrides can fall in a different week from their original date.
    for (const [dateKey, override] of Object.entries(overrides)) {
      if (exceptions.includes(dateKey) || (event.repeatEndDate && dateKey > event.repeatEndDate)) continue;
      if (new Date(override.endUTC) > from && new Date(override.startUTC) < to) {
        expanded.push({...event, ...occurrenceSetupFields(event, dateKey), ...override, isRecurringInstance: true, instanceDate: dateKey});
      }
    }
    // align first occurrence on/after `from`
    let nDays = 0;
    if (from > start) {
      const diff = Math.floor((from - start)/86400000);
      const r = diff % stepDays;
      nDays = r === 0 ? diff : diff + (stepDays - r);
    }

    while (true) {
      const instStart = new Date(start);
      instStart.setDate(start.getDate() + nDays);
      if (until && instStart > until) break;
      if (instStart > to) break;

      const dateKey = instStart.toISOString().slice(0,10);
      if (!exceptions.includes(dateKey) && !overrides[dateKey]) {
        const instEnd = new Date(instStart.getTime() + durMs);
        let instance = {
          ...event,
          ...occurrenceSetupFields(event, dateKey),
          startUTC: instStart.toISOString(),
          endUTC: instEnd.toISOString(),
          isRecurringInstance: true,
          instanceDate: dateKey
        };

        if (instEnd >= from) expanded.push(instance);
      }
      nDays += stepDays;
    }
  }
  return expanded;
};

// Optional convenience export
const recurrenceUtils = { expandRecurring };

export default recurrenceUtils;
